import { calendarPanelClassNames } from '../../v2/DatePicker/DatePicker';
import inputClassNames from './DateInput.module.scss';

export const dateInputClassNames = {
  ...calendarPanelClassNames,
  ...inputClassNames,
};

// The V2 panel carries its own padding, so the popover must not add more.
export const calendarDropdownStyles = { dropdown: { padding: 0 } };

export { calendarPanelProps } from '../../v2/DatePicker/DatePicker';
